// src/Components/AssignPackageModal.js
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Config";
import "./AssignPackageModal.css"; // External styles for better customization

Modal.setAppElement("#root");

const AssignPackageModal = ({ isOpen, onRequestClose, userId }) => {
  const [agents, setAgents] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userId) {
      fetchAgents(userId);
      fetchPackages(userId);
    }
  }, [userId]);

  const fetchAgents = async (userId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}Company_Agents?Userid=${userId}`
      );
      const agentOptions = response.data.agents.map((agent) => ({
        value: agent.agentId,
        label: agent.name,
      }));
      setAgents(agentOptions);
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  const fetchPackages = async (userId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}RetailCompanyPackage?id=${userId}`
      );
      const packageOptions = response.data.packages.map((pkg) => ({
        value: pkg.packageid,
        label: pkg.packageName,
      }));
      setPackages(packageOptions);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  const handleAssignPackage = async () => {
    if (!selectedAgent || !selectedPackage) {
      Swal.fire(
        "Validation Error",
        "Please select both an agent and a package.",
        "warning"
      );
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}AssignPackage`,
        {
          salesAgentProfileId: selectedAgent.value,
          packagesId: selectedPackage.value,
        },
        {
          headers: { accept: "*/*", "Content-Type": "application/json" },
        }
      );

      if (response.data.responseCode === "0000") {
        Swal.fire("Success", "Package assigned successfully.", "success");
        onRequestClose(); 
      } 
      else {
        Swal.fire("Error", response.data.message, "error");
      }
    } catch (error) {
      console.error("Error assigning package:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "An error occurred.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
   <Modal
  isOpen={isOpen}
  onRequestClose={onRequestClose}
  contentLabel="Assign Package Modal"
  style={{
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxWidth: "600px",
      padding: "25px",
      borderRadius: "12px",
      backgroundColor: "#fff",
      boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  }}
>
  <div className="assign-package-modal">
    <div className="modal-header">
      <h5 className="modal-title w-100 text-center">Assign Package to Agent</h5>
    </div>

    <div className="modal-body">
      <div className="form-group mb-3">
        <label className="form-label">Agent</label>
        <Select
          options={agents}
          value={selectedAgent}
          onChange={setSelectedAgent}
          isLoading={loading}
          placeholder="Select an Agent"
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </div>

      <div className="form-group mb-3">
        <label className="form-label">Package</label>
        <Select
          options={packages}
          value={selectedPackage}
          onChange={setSelectedPackage}
          isLoading={loading}
          placeholder="Select a Package"
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </div>

      <div className="modal-footer">
        <button
          className="btn btn-secondary"
          onClick={onRequestClose}
          disabled={loading}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={handleAssignPackage}
          disabled={loading}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Assign Package"
          )}
        </button>
      </div>
    </div>
  </div>
</Modal>

  );
};

export default AssignPackageModal;
